// components/LandingPage.jsx

import React from "react";

import Header from "./Header";
import Hero from "./Hero";
import SignatureSection from "./SignatureSection";
import AboutSection from "./AboutSection";
import GallerySection from "./GallerySection";
import ReservationSection from "./ReservationSection";
import ContactSection from "./ContactSection";
import Footer from "./Footer";
//import { ReactGoogleReviews } from "react-google-reviews";
//import "react-google-reviews/dist/index.css";

export default function LandingPage() {

  return (
    <>
     <Header />
    
      <Hero />

      <SignatureSection />

      <AboutSection />

      <GallerySection />

      <ReservationSection />

      <ContactSection /> 

      <Footer />
    </>
  );
}